import React from 'react';

import { getAPI, postAPI } from '../utils/APIUtils';
import { downloadData, uploadData } from 'aws-amplify/storage';

import { styled } from '@mui/material/styles'

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import DownloadIcon from '@mui/icons-material/Download';
import ReplayIcon from '@mui/icons-material/Replay';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import Link from '@mui/material/Link';

import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LabelIcon from '@mui/icons-material/Label';
import NoteIcon from '@mui/icons-material/Note';
import Divider from '@mui/material/Divider';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DriveFileMoveOutlineIcon from '@mui/icons-material/DriveFileMoveOutline';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import DeleteIcon from '@mui/icons-material/Delete';

import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Chip from '@mui/material/Chip';

import { State, Catalog, Act } from '../states/settingState';
import { CatalogUpdateForJSONDialog } from './CatalogUpdateForJSONDialog';
import { CatalogUpdateMoveActDialog } from './CatalogUpdateMoveActDialog';
import { CatalogUpdateNameDialog } from './CatalogUpdateNameDialog';
import { CatalogUpdateAddCatalogDialog } from './CatalogUpdateAddCatalogDialog';

type Props = {
  catalogState: State | undefined;
  catalogs?: Catalog[];
  maxCatalogId: number;
  accountid: string;
  idid: string;
  role: string;
  handleCommit: (fileName: string) => void;
  renewCatalogState: () => void;
  renewCatalogs: (cs: Catalog[]) => void;
  setMaxCatalogId: (id: number) => void;
  setLoading: (loading: boolean) => void;
};

const HenResultCatalogListItem = styled(ListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(0),
}));
const SyoResultCatalogListItem = styled(ListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(2),
}));
const SetuResultCatalogListItem = styled(ListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(4),
}));
const KanResultCatalogListItem = styled(ListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(6),
}));
const MokuResultCatalogListItem = styled(ListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(8),
}));

const CATALOT_DIVISION_NUM = 100;
const getDivisionCatalogs = (cs: Catalog[]) => {
  const f = (cs2: Catalog[]) => {
    let count = 0;
    cs2.forEach((c) => {
      count += c.acts.length;
      if (c.child) {
        count += f(c.child);
      }
    });
    return count;
  };
  const ncs = cs.map((c) => {
    if (c.child) {
      return c.acts.length + f(c.child);
    }
    return c.acts.length;
  });

  const result: Catalog[][] = [];
  let sub: Catalog[] = [];
  let subCount = 0;
  ncs.forEach((n, i) => {
    sub.push(cs[i]);
    subCount += n;
    if (subCount > CATALOT_DIVISION_NUM) {
      result.push(sub);
      sub = [];
      subCount = 0;
    }
  });
  if (sub.length > 0) {
    result.push(sub);
  }
  return result;
};

export const CatalogUpdatePanel: React.FC<Props> = (props) => {

  const downloadFormLGWAN = async (path: string) => {
    const apiurl = `/tempfile?path=private/${props.idid}/${path}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const downloadForm = async (path: string) => {
    const downloadTask = await downloadData({
      path: `private/${props.idid}/${path}`,
    });
    const { body } = await downloadTask.result;
    const blob = new Blob([await body.blob()]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const handleLastResultDownload = async () => {
    if (props.catalogState && props.catalogState.outPath) {
      props.setLoading(true);

      try {
        const tmp: string = props.catalogState.outPath;
        const newOutPath = tmp.replace(/private\/.*?\//, '');
        if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
          downloadFormLGWAN(newOutPath);
        } else {
          downloadForm(newOutPath);
        }

      } catch (e) {
        // エラー
        console.log(e);
      }

      props.setLoading(false);
    }
  };
  const handleRenewCatalogState = () => {
    props.setLoading(true);
    props.renewCatalogState();
  };

  const handleCatalogUpdateForJSON = () => {
    setSubDialog(true);
  };

  const [catalogNameDialog, setCatalogNameDialog] = React.useState(false);
  const openCatalogNameDialog = Boolean(catalogNameDialog);
  const closeCatalogNameDialog = () => setCatalogNameDialog(false);
  const [catalogNameObject, setCatalogNameObject] = React.useState<undefined | Catalog>(undefined);

  const setEditCatalogName = (name: string) => {
    const c: Catalog = JSON.parse(JSON.stringify(catalogNameObject));
    c.name = name;
    setCatalogNameObject(c);
  };

  const handleOkEditCatalogName = (catalogId: string, name: string) => {
    const cs: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));
    const catalog = fCatalogsForCatalogId(cs, catalogId);
    if (catalog) {
      catalog.name = name;
      props.renewCatalogs(cs);
      setCatalogNameObject(undefined);
    }
  };

  const handleEditCatalogName = (c: Catalog) => {
    setCatalogNameObject(c);
    setCatalogNameDialog(true);
  };

  const [catalogAddDialog, setCatalogAddDialog] = React.useState(false);
  const openCatalogAddDialog = Boolean(catalogAddDialog);
  const closeCatalogAddDialog = () => setCatalogAddDialog(false);
  const [catalogAddObject, setCatalogAddObject] = React.useState<undefined | Catalog>(undefined);
  const [catalogAddTargetObject, setCatalogAddTargetObject] = React.useState<undefined | Catalog>(undefined);

  const setEditCatalogAddName = (name: string) => {
    const c: Catalog = JSON.parse(JSON.stringify(catalogAddObject));
    c.name = name;
    setCatalogAddObject(c);
  };

  const handleOkEditCatalogAdd = () => {
    const f = (cs: Catalog[], cid: string): [number, Catalog[] | undefined] => {
      let i = 0;
      for (const c of cs) {
        if (c.id === cid) return [i, cs];
        if (c.child) {
          const r = f(c.child, cid);
          if (r[0] !== -1) {
            return r;
          }
        }
        i += 1;
      }
      return [-1, undefined];
    };
    const cs: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));
    if (catalogAddTargetObject) {
      const [taegetIndex, targetCS] = f(cs, catalogAddTargetObject.id);
      if (targetCS && catalogAddObject) {
        targetCS.splice(taegetIndex + 1, 0, catalogAddObject);
        props.renewCatalogs(cs);
        props.setMaxCatalogId(Number(catalogAddObject.id));
      }
    }
  };

  const handleAddCatalog = (c: Catalog) => {
    const newC: Catalog = JSON.parse(JSON.stringify(c));
    setCatalogAddTargetObject(newC);
    const addC: Catalog = {
      id: '' + (props.maxCatalogId + 1),
      name: '',
      acts: [],
    };
    setCatalogAddObject(addC);
    setCatalogAddDialog(true);
  };

  const [catalogAddChildDialog, setCatalogAddChildDialog] = React.useState(false);
  const openCatalogAddChildDialog = Boolean(catalogAddChildDialog);
  const closeCatalogAddChildDialog = () => setCatalogAddChildDialog(false);
  const [catalogAddChildObject, setCatalogAddChildObject] = React.useState<undefined | Catalog>(undefined);
  const [catalogAddChildTargetObject, setCatalogAddChildTargetObject] = React.useState<undefined | Catalog>(undefined);

  const setEditCatalogAddChildName = (name: string) => {
    const c: Catalog = JSON.parse(JSON.stringify(catalogAddChildObject));
    c.name = name;
    setCatalogAddChildObject(c);
  };

  const handleOkEditCatalogAddChild = () => {
    const f = (cs: Catalog[], cid: string, addCatalog: Catalog) => {
      for (const c of cs) {
        if (c.id === cid) {
          if (c.child) {
            c.child.unshift(addCatalog);
          } else {
            c.child = [addCatalog];
          }
          c.acts = [];
          return true;
        }
        if (c.child) {
          if (f(c.child, cid, addCatalog)) {
            return true;
          }
        }
      }
      return false;
    };
    const cs: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));
    if (catalogAddChildTargetObject) {
      if (catalogAddChildTargetObject && catalogAddChildObject) {
        catalogAddChildObject.acts = catalogAddChildTargetObject.acts;
        f(cs, catalogAddChildTargetObject.id, catalogAddChildObject);

        props.renewCatalogs(cs);
        props.setMaxCatalogId(Number(catalogAddChildObject.id));
      }
    }
  };

  const handleAddChildCatalog = (c: Catalog) => {
    const newC: Catalog = JSON.parse(JSON.stringify(c));
    setCatalogAddChildTargetObject(newC);
    const addC: Catalog = {
      id: '' + (props.maxCatalogId + 1),
      name: '',
      acts: [],
    };
    setCatalogAddChildObject(addC);
    setCatalogAddChildDialog(true);
  };

  const handleDeleteCatalog = (catalog: Catalog) => {
    const newCS: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));

    const f = (cs: Catalog[]) => {
      let index = 0;
      for (const c of cs) {
        if (c.id === catalog.id) {
          cs.splice(index, 1);
          return true;
        }
        if (c.child) {
          if (f(c.child)) {
            return true;
          }
        }
        index += 1;
      }
      return false;
    };
    if (f(newCS)) {
      props.renewCatalogs(newCS);
    }
  };

  const createCatalogAction = (c: Catalog) => {
    return c.id === '0' ? (
      <>
        <Tooltip title="体系目次を次に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddCatalog(c)}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
      </>
    ) : (c.acts.length === 0 && (!c.child || c.child.length === 0)) ? (
      <>
        <Tooltip title="目次を削除する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleDeleteCatalog(c)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="名称を編集する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleEditCatalogName(c)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="体系目次を次に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddCatalog(c)}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="体系目次を子に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddChildCatalog(c)}>
            <AddCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      </>
    ) : (
      <>
        <Tooltip title="名称を編集する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleEditCatalogName(c)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="体系目次を次に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddCatalog(c)}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="体系目次を子に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddChildCatalog(c)}>
            <AddCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const createCatalog = (level: number, c: Catalog) => {
    return level === 0 ? (
      <HenResultCatalogListItem secondaryAction={
        createCatalogAction(c)
      } key={`catalog-${c.id}-${level}`}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </HenResultCatalogListItem>
    ) : level === 1 ? (
      <SyoResultCatalogListItem secondaryAction={
        createCatalogAction(c)
      } key={`catalog-${c.id}-${level}`}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </SyoResultCatalogListItem>
    ) : level === 2 ? (
      <SetuResultCatalogListItem secondaryAction={
        createCatalogAction(c)
      } key={`catalog-${c.id}-${level}`}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </SetuResultCatalogListItem>
    ) : level === 3 ? (
      <KanResultCatalogListItem secondaryAction={
        createCatalogAction(c)
      } key={`catalog-${c.id}-${level}`}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </KanResultCatalogListItem>
    ) : (
      <MokuResultCatalogListItem secondaryAction={
        createCatalogAction(c)
      } key={`catalog-${c.id}-${level}`}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={c.name} />
      </MokuResultCatalogListItem>
    );
  }

  const handleMoveAct = (catalogId: string, actId: string) => {
    setSelectedMoveAct(actId);
    setSelectedMoveCatalog(catalogId);
    setMoveActDialog(true);
  };

  const fCatalogsForCatalogId = (cs: Catalog[], catalogId: string): undefined | Catalog => {
    let catalog: undefined | Catalog = undefined;
    for (const c of cs) {
      if (c.id === catalogId) {
        catalog = c;
        break;
      }
      if (c.child) {
        catalog = fCatalogsForCatalogId(c.child, catalogId);
        if (catalog) break;
      }
    };
    return catalog;
  };
  const handleUpAct = (catalogId: string, actId: string) => {
    props.setLoading(true);
    const cs: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));
    const catalog = fCatalogsForCatalogId(cs, catalogId);
    if (catalog) {
      const targetI = catalog.acts.findIndex((a) => a.actId === actId);
      [catalog.acts[targetI - 1], catalog.acts[targetI]] = [catalog.acts[targetI], catalog.acts[targetI - 1]];
      props.renewCatalogs(cs);
    }
    props.setLoading(false);
  };
  const handleDownAct = (catalogId: string, actId: string) => {
    props.setLoading(true);
    const cs: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));
    const catalog = fCatalogsForCatalogId(cs, catalogId);
    if (catalog) {
      const targetI = catalog.acts.findIndex((a) => a.actId === actId);
      [catalog.acts[targetI], catalog.acts[targetI + 1]] = [catalog.acts[targetI + 1], catalog.acts[targetI]];
      props.renewCatalogs(cs);
    }
    props.setLoading(false);
  };

  const createActsAction = (ir: number, length: number, catalogId: string, actId: string) => {
    const moveup = ir !== 0 ? (
      <Tooltip title="表示順を1つ上に移動する">
        <IconButton sx={{
          color: (theme) => theme.palette.secondary.main,
          margin: 1,
        }} edge="end" aria-label="addCatalog" onClick={() => handleUpAct(catalogId, actId)}>
          <MoveUpIcon />
        </IconButton>
      </Tooltip>
    ) : '';
    const movedown = ir < length - 1 ? (
      <Tooltip title="表示順を1つ下に移動する">
        <IconButton sx={{
          color: (theme) => theme.palette.secondary.main,
          margin: 1,
        }} edge="end" aria-label="addCatalog" onClick={() => handleDownAct(catalogId, actId)}>
          <MoveDownIcon />
        </IconButton>
      </Tooltip>
    ) : '';
    return (
      <>
        <Tooltip title="体系目次を移動する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleMoveAct(catalogId, actId)}>
            <DriveFileMoveOutlineIcon />
          </IconButton>
        </Tooltip>
        {moveup}
        {movedown}
      </>
    );
  };

  const createActs = (level: number, catalogId: string, acts: Act[], view: React.JSX.Element[]) => {
    const lview: React.JSX.Element[] = [];
    const f = (actState, theme) => {
      return actState && actState !== 0 ? theme.palette.secondary[50] : theme.palette.primary[50];
    };
    // LEG-17: 廃止・失効した例規（actState が 0=有効 以外）に文言ラベルを付ける
    const f2 = (actState) => {
      return actState && actState !== 0 ? (
        <Chip label="廃止・失効" size="small" color="warning" variant="outlined" />
      ) : '';
    };
    acts.forEach((r, ir) => {
      lview.push(
        <div key={`result-${level}-${catalogId}-${r.actId}-${ir}`}>
          <ListItem secondaryAction={
            createActsAction(ir, acts.length, catalogId, r.actId)
          }
            sx={{
              backgroundColor: (theme) => f(r.actState, theme),
            }}
          >
            <ListItemIcon sx={{
              color: (theme) => theme.palette.primary.main,
              margin: 1,
            }}>
              <NoteIcon />
            </ListItemIcon>
            <ListItemText primary={
              <>
                <Typography variant="body1" component="span" sx={{
                  width: '70%',
                  verticalAlign: 'middle',
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }} >{r.title}{f2(r.actState)}</Typography>
              </>
            } secondary={
              <>
                <Typography variant="subtitle1" component="span">番号：</Typography>
                <Typography variant="body1" component="span">{r.actNum}</Typography>
              </>
            } />
          </ListItem>
          <Divider />
        </div>
      );
    });
    view.push(
      <Paper key={`acts-${level}-${catalogId}`}
        sx={{
          minWidth: 275,
          margin: 1,
          padding: 1,
          backgroundColor: (theme) => theme.palette.primary[50],
        }} elevation={3}>
        <List component="nav">
          {lview}
        </List>
      </Paper>
    );
  };

  const fTree = (level: number, cs: Catalog[], view: React.JSX.Element[]) => {
    cs.forEach((c, index) => {
      if (c.id === '9999') return;
      view.push((
        <Paper key={`catalogs-${level}-${c.id}`}
          sx={{
            minWidth: 275,
            margin: 1,
          }} elevation={3}>
          <List>
            {createCatalog(level, c)}
          </List>
        </Paper>
      ));

      if (c.child && c.child.length > 0) {
        fTree(level + 1, c.child, view);
      }

      if (c.acts && c.acts.length > 0) {
        createActs(level, c.id, c.acts, view);
      }
    });
  };

  const getTimestump = () => {
    const date = new Date();
    const yyyy = `${date.getFullYear()}`;
    const MM = `0${date.getMonth() + 1}`.slice(-2); // getMonth()の返り値は0が基点
    const dd = `0${date.getDate()}`.slice(-2);
    const HH = `0${date.getHours()}`.slice(-2);
    const mm = `0${date.getMinutes()}`.slice(-2);
    const ss = `0${date.getSeconds()}`.slice(-2);

    return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
  };

  const handleCommit = async () => {
    props.setLoading(true);
    const fileName = 'Catalog_' + getTimestump() + '.json';

    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
      const apiurl = `/tempfile`;
      const options = {
        path: `private/${props.idid}/${fileName}`,
        contenttype: 'application/json',
      };
      const json = await postAPI(apiurl, options);
      const realuploadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.uploadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.uploadUrl;

      const uploadResponse = await fetch(realuploadurl, {
        method: 'PUT',
        body: JSON.stringify(props.catalogs),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!uploadResponse.ok) {
        console.error('アップロード失敗', uploadResponse.status, uploadResponse.statusText);
      }

    } else {
      await uploadData({
        path: `private/${props.idid}/${fileName}`,
        data: JSON.stringify(props.catalogs),
      });
    }

    props.handleCommit(fileName);
  };

  const [subDialog2, setSubDialog2] = React.useState(false);
  const openSubDialog2 = Boolean(subDialog2);
  const closeSubDialog2 = () => setSubDialog2(false);
  const okSubDialog2 = () => {
    closeSubDialog2();
    handleCommit();
  };

  const confirmationCommit = () => {
    setSubDialog2(true);
  };

  const createCommitButton = () => {
    return (
      <Button variant="contained" color={'secondary'} endIcon={<SendIcon />} onClick={confirmationCommit}>
        登録
      </Button>
    );
  };

  const [currentPage, setCurrentPage] = React.useState(1);
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const createTree = () => {
    const view: React.JSX.Element[] = [];
    if (props.catalogs) {
      const vCatalogs = getDivisionCatalogs(props.catalogs);
      console.log(vCatalogs);
      fTree(0, vCatalogs[currentPage - 1], view);

      return (
        <>
          {createCommitButton()}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 1 }}>
            <Pagination count={vCatalogs.length} page={currentPage} color="secondary" onChange={handleChange} />
          </Box>
          {view}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 1 }}>
            <Pagination count={vCatalogs.length} page={currentPage} color="secondary" onChange={handleChange} />
          </Box>
          {createCommitButton()}
        </>
      );
    }
    return (
      <>
        {view}
      </>
    );
  };

  const createCatalogUpdateForJSON = () => {
    return props.role === 'Manager' ? (
      <>
        <Link component="button" underline="always" color={'secondary'} onClick={handleCatalogUpdateForJSON}>設定ファイルから体系目次を更新</Link>
        <br />
      </>
    ) : '';
  };

  const createContents = () => {
    if (props.catalogState && props.catalogState.state === 'Processing') {
      return (
        <>
          <Typography variant="body1" component="span">体系目次の更新中です。</Typography>
          <Tooltip title="更新">
            <IconButton size={'large'} sx={{
              color: (theme) => theme.palette.secondary.main,
              position: 'relative',
              left: 5,
            }} edge="end" aria-label="enforcedate" onClick={handleRenewCatalogState}>
              <ReplayIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </>
      );
    } else if (props.catalogState && props.catalogState.state === 'Accepting') {
      if (Array.isArray(props.catalogs)) {
        const lastResult = props.catalogState.outPath ? (
          <>
            <Typography variant="body1" component="span">前回の実行結果をダウンロード</Typography>
            <Tooltip title="ダウンロード">
              <IconButton size={'large'} sx={{
                color: (theme) => theme.palette.secondary.main,
                position: 'relative',
                left: 5,
              }} edge="end" aria-label="enforcedate" onClick={handleLastResultDownload}>
                <DownloadIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <br />
            {createCatalogUpdateForJSON()}
            <br />
            {createTree()}
            <br />
          </>
        ) : (
          <>
            {createCatalogUpdateForJSON()}
            <br />
            {createTree()}
            <br />
          </>
        );

        return (
          <>
            {lastResult}
          </>
        );
      }

      // 更新中エラー
      return (
        <>
          <Typography variant="body1" component="span">体系目次または分野の更新中です。</Typography>
          <p />
          <Typography variant="body1" component="span">しばらく待ってから再度お試しください。</Typography>
        </>
      );
    }
    return '';
  };

  const [subDialog, setSubDialog] = React.useState(false);
  const openSubDialog = Boolean(subDialog);
  const closeSubDialog = () => setSubDialog(false);

  const [moveActDialog, setMoveActDialog] = React.useState(false);
  const openMoveActDialog = Boolean(moveActDialog);
  const closeMoveActDialog = () => {
    setMoveActDialog(false);
    setSelectedMoveAct('');
    setSelectedMoveCatalog('');
  };
  const deleteActForCatalog = (catalogs: Catalog[], actId: string): Act | undefined => {
    for (const catalog of catalogs) {
      const index = catalog.acts.findIndex(a => a.actId === actId);
      if (index !== -1) {
        const act = JSON.parse(JSON.stringify(catalog.acts[index]));
        catalog.acts.splice(index, 1);
        return act;
      }
      if (catalog.child) {
        const result = deleteActForCatalog(catalog.child, actId);
        if (result) return result;
      }
    }
    return undefined;
  };
  const addActForCatalog = (catalogs: Catalog[], catalogId: string, act: Act): boolean => {
    for (const catalog of catalogs) {
      if (catalog.id === catalogId) {
        catalog.acts.push(act);
        return true;
      }
      if (catalog.child) {
        const added = addActForCatalog(catalog.child, catalogId, act);
        if (added) return true;
      }
    }
    return false;
  };
  const commitMoveActDialog = (catalogId: string, actId: string) => {
    props.setLoading(true);
    const c: Catalog[] = JSON.parse(JSON.stringify(props.catalogs));
    const act = deleteActForCatalog(c, actId);
    if (act) {
      addActForCatalog(c, catalogId, act);
      props.renewCatalogs(c);
    }
    closeMoveActDialog();
    props.setLoading(false);
  };

  const [selectedMoveAct, setSelectedMoveAct] = React.useState('');
  const [selectedMoveCatalog, setSelectedMoveCatalog] = React.useState('');

  return (
    <>
      {createContents()}
      <CatalogUpdateForJSONDialog
        open={openSubDialog}
        accountid={props.accountid}
        idid={props.idid}
        handleCommit={props.handleCommit}
        handleClose={closeSubDialog}
        setLoading={props.setLoading}
      />
      <CatalogUpdateMoveActDialog
        open={openMoveActDialog}
        currentActId={selectedMoveAct}
        currentCatalogId={selectedMoveCatalog}
        catalogs={props.catalogs}
        handleClose={closeMoveActDialog}
        handleCommit={commitMoveActDialog}
      />
      <CatalogUpdateNameDialog
        open={openCatalogNameDialog}
        catalog={catalogNameObject}
        setEditCatalogName={setEditCatalogName}
        handleCommit={handleOkEditCatalogName}
        handleClose={closeCatalogNameDialog}
      />
      <CatalogUpdateAddCatalogDialog
        open={openCatalogAddDialog}
        catalog={catalogAddObject}
        setEditCatalogName={setEditCatalogAddName}
        handleCommit={handleOkEditCatalogAdd}
        handleClose={closeCatalogAddDialog}
      />
      <CatalogUpdateAddCatalogDialog
        open={openCatalogAddChildDialog}
        catalog={catalogAddChildObject}
        setEditCatalogName={setEditCatalogAddChildName}
        handleCommit={handleOkEditCatalogAddChild}
        handleClose={closeCatalogAddChildDialog}
      />
      <Dialog
        open={openSubDialog2}
        keepMounted
        onClose={closeSubDialog2}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">体系の登録</DialogTitle>
        <DialogContent>
          <Typography>{'この処理には時間がかかる場合があります。よろしいですか？'}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={okSubDialog2} color="primary">
            OK
          </Button>
          <Button onClick={closeSubDialog2} color="primary">
            キャンセル
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};